import { Wine } from "lucide-react";
import FnbKDS from "./FnbKDS";
export default function FnbBar() {
  return <FnbKDS filterKind="bar" title="Bar Display" Icon={Wine} testidPrefix="bar"/>;
}
